import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbExportPageService } from './service/cmdb-export-page.service';
import * as CryptoJS from 'crypto-js';
import { faCopy, faDownload, faFileExport, faTrash } from '@fortawesome/free-solid-svg-icons';
import { param } from 'jquery';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-cmdb-export-page',
	templateUrl: './cmdb-export-page.component.html',
	styleUrls: ['./cmdb-export-page.component.scss'],
})
export class CmdbExportPageComponent implements OnInit {
	isLoadingLabels = true;
	simpleKey = 'simpleKey';

	icons = {
		faTrash: faTrash,
		faFileExport: faFileExport,
		faCopy: faCopy,
	};

	labels: LabelsInterface = {
		lbl_asset_inventario: 'CMDB',
		lbl_edocs_carregando: 'Loading',
		lbl_geral_selecione: 'SELECT',
		lbl_extracao_dados_cmdb: '',
		lbl_rep_custom_nome: '',
		lbl_geral_salvar: 'Save',
		lbl_geral_exportar_excel: 'Export to microsoft excel',
		lbl_ckp_deletar_este_indicador: 'Delete this indicator',
		lbl_report_no_report: '',
		lbl_rep_custom: '',
		lbl_aguarde_processamento_demorar: '',
		lbl_copiar_area_transferencia: '',
		lbl_copiado_transferencia: '',
		lbl_relatorios_salvos: '',
	};

	constructor(
		private CmdbExportPageService: CmdbExportPageService,
		private LabelsService: LabelsService,
		private Router: Router,
		private NotificationService: NotificationService,
		private ExcelService: ExcelService,
		private CryptoService: CryptoService,
		private ActivatedRoute: ActivatedRoute,
		private ProfileService: ProfileService
	) {}

	savedReports: { name: string; params: genericFormInterface[] }[] = [];
	selectedFilters: genericFormInterface[] = [];
	reportName = 'Report';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		if (localStorage.getItem('cmdbSavedExport')) {
			const cmdbSavedExport = CryptoJS.AES.decrypt(localStorage.getItem('cmdbSavedExport'), this.simpleKey).toString(
				CryptoJS.enc.Utf8
			);
			this.savedReports = JSON.parse(cmdbSavedExport);
		}

		this.ActivatedRoute.queryParams.subscribe((parameters) => {
			if (parameters && parameters.p) {
				const filters = JSON.parse(this.CryptoService.decryptB64(parameters.p));
				this.selectedFilters = filters;
			}
		});
	}

	saveReport(): void {
		const minifySelectedFilters: genericFormInterface[] = [];
		for (const filter of this.selectedFilters) {
			const newFilter: genericFormInterface = {
				name: filter.name,
				values: filter.values,
				label: '',
				inputType: '',
				id: '',
			};

			minifySelectedFilters.push(newFilter);
		}
		const toSaveReport = { name: this.reportName, params: minifySelectedFilters };
		this.savedReports.push(toSaveReport);
		this.saveSavedReportOnStorage();
	}

	removeSavedReport(index: number): void {
		this.savedReports.splice(index, 1);
		this.saveSavedReportOnStorage();
	}

	saveSavedReportOnStorage(): void {
		const cmdbSavedExport = CryptoJS.AES.encrypt(JSON.stringify(this.savedReports), this.simpleKey).toString();
		localStorage.setItem('cmdbSavedExport', cmdbSavedExport);
	}

	exportSavedReport(index?: number): void {
		const parameters = this.convertReportParamsToQuery(index);

		this.NotificationService.setNotificationMessage(this.labels.lbl_aguarde_processamento_demorar);
		this.CmdbExportPageService.getExportableCMDBList(parameters).subscribe((spreadsheet) => {
			if (
				!spreadsheet.lines ||
				spreadsheet.lines.length === 0 ||
				!spreadsheet.lines[0].cells ||
				spreadsheet.lines[0].cells.length === 0
			) {
				this.NotificationService.setNotificationMessage('_Não encontramos nenhum resultado com este filtro!');
				return;
			}
			this.ExcelService.exportExcel(spreadsheet, index == undefined ? this.reportName : this.savedReports[index].name);
		});
	}

	copyToClipboard(index?: number): void {
		if (index && this.savedReports[index].params.length === 0 && !index && this.selectedFilters && this.selectedFilters.length === 0)
			return;

		const parameters = index === undefined ? this.selectedFilters : this.savedReports[index].params;

		const minifySelectedFilters: genericFormInterface[] = [];
		for (const filter of parameters) {
			const newFilter: genericFormInterface = {
				name: filter.name,
				values: filter.values,
				label: '',
				inputType: '',
				id: '',
			};

			minifySelectedFilters.push(newFilter);
		}

		const b64Parameters = this.CryptoService.encryptB64(JSON.stringify(minifySelectedFilters));
		const b64UserCustomerId = this.CryptoService.encryptB64(this.ProfileService.userData().idCustomer);
		const b64Usertype = this.CryptoService.encryptB64(this.ProfileService.userData().usertype);
		const b64UserLanguage = this.CryptoService.encryptB64(this.ProfileService.userData().language);

		navigator.clipboard.writeText(
			location.host +
				'/report/cmdb/download?p=' +
				b64Parameters +
				'&c=' +
				b64UserCustomerId +
				'&t=' +
				b64Usertype +
				'&l=' +
				b64UserLanguage
		);
		this.NotificationService.setNotificationMessage(this.labels.lbl_copiado_transferencia);
	}

	convertReportParamsToQuery(index?: number): string {
		let parameters = '';
		const parameterList: genericFormInterface[] = index == undefined ? this.selectedFilters : this.savedReports[index].params;

		for (const [plIndex, parameter] of parameterList.entries()) {
			parameters += `${plIndex == 0 ? '' : '&'}${parameter.name}=`;
			const values = parameter.values.filter((value) => value.toString().trim() !== '');
			parameters += values.join('§');
		}

		parameters += `&max_quantity=0`;
		return parameters;
	}

	redirectTo(to: string): void {
		this.Router.navigate([to]);
	}
}
